export const USER_ACTION_TYPE = {
	user: ' user',
	verify: 'verify',
	status: 'Status',
	adminRole: 'adminRole',
	taxproRole: 'taxproRole',
	customerRole: 'customerRole',
	accountManagerRole: 'accountManagerRole',
	reset: 'reset',
	statusId: 'statusId',
	existEmail: 'existEmail',
	existEmailReset: 'existEmailReset',
	addExistingUser: 'addExistingUser',

		//create E-sign request
		esignRequestIdle: 'esignRequestIdle',
		esignRequestSuccess: 'esignRequestSuccess',
		esignRequestError: 'esignRequestError',		

		//create E-sign request
		contractSignRequestCustomerIdle: 'contractSignRequestCustomerIdle',
		contractSignRequestCustomerSuccess: 'contractSignRequestCustomerSuccess',
		contractSignRequestCustomerError: 'contractSignRequestCustomerError',	

		// getLeadsTaxProList
		getLeadsTaxProListIdle: 'getLeadsTaxProListIdle',
		getLeadsTaxProListSuccess: 'getLeadsTaxProListSuccess',
		getLeadsTaxProListError: 'getLeadsTaxProListError',	

		// switch-lead dashboard
		switchLeadDashboardIdle: 'switchLeadDashboardIdle',
		switchLeadDashboardSuccess: 'switchLeadDashboardSuccess',
		switchLeadDashboardError: 'switchLeadDashboardError',	
		// get-document data
		getDocumentDataSuccess: 'getDocumentDataSuccess',

		// get-assessment data
		getAssessmentLoading: 'getAssessmentLoading',
		getAssessmentSuccess: 'getAssessmentSuccess',
		getAssessmentError: 'getAssessmentError',
};
